<main class="auth-shell flex min-h-screen justify-center px-2 pb-6 pt-12 sm:px-4 sm:py-10">
  <nz-card class="policy-card h-fit w-full max-w-3xl">
    @if (document(); as doc) {
      <app-policy-view [document]="doc"/>
    } @else {
      <div class="flex justify-center py-6">
        <nz-spin nzSimple></nz-spin>
      </div>
    }
  </nz-card>
</main>
